import React from "react";
import C3Chart from "react-c3js";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import { defaultStartDate } from "./chartUtils";

function tooltipContents(d, defaultTitleFormat, defaultValueFormat, color) {
  var $$ = this,
    config = $$.config,
    CLASS = $$.CLASS,
    titleFormat = config.tooltip_format_title || defaultTitleFormat,
    nameFormat =
      config.tooltip_format_name ||
      function (name) {
        return name;
      },
    valueFormat = config.tooltip_format_value || defaultValueFormat,
    text,
    i,
    title,
    value,
    name,
    bgcolor;

  for (i = 0; i < d.length; i++) {
    if (!(d[i] && (d[i].value || d[i].value === 0))) {
      continue;
    }
    if (d[i].name === "data2") {
      continue;
    }
    if (!text) {
      title = "MY TOOLTIP";
      text =
        "<table class='" +
        CLASS.tooltip +
        "'>" +
        (title || title === 0
          ? "<tr><th colspan='2'>" + d[i].name + "</th></tr>"
          : "");
    }
    name = nameFormat(d[i].name);
    value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
    bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);

    text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
    text +=
      "<td class='name'><span style='background-color:" +
      bgcolor +
      "'></span>Percentage</td>";
    text += "<td class='value'>" + value + "</td>";
    text += "</tr>";
    text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
    text +=
      "<td class='name'><span style='background-color:" +
      bgcolor +
      "'></span>Count</td>";
    text += "<td class='value'>" + d[i].value + "</td>";
    text += "</tr>";
  }
  return text + "</table>";
}

export default class ReportLogsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      chartData: {
        columns: [
          ["Failure", 0],
          ["Success", 0],
        ],
        type: "donut",
      },
    };
  }

  componentDidMount() {
    this.fetchData(this.state.startDate, this.state.endDate);
  }

  async fetchData(startDate, endDate) {
    const chartData = {
      columns: [
        ["Failure", 0],
        ["Success", 0],
      ],
      type: "donut",
    };

    try {
      const res = await clientService.getReportLogs(startDate, endDate);
      if (res.data && res.data.length > 0) {
        chartData.columns = res.data.map((m) => [
          m.status.charAt(0).toUpperCase() + m.status.slice(1),
          m.count,
        ]);
      }
    } catch (err) {
      console.error(err);
    }
    this.setState({ chartData });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData(this.state.startDate, this.state.endDate);
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.setState({ startDate: date })}
          onEndChange={(date) => this.setState({ endDate: date })}
          onSubmit={this.handleSubmit}
          layout="wide"
        />
        <AnalyticsChartCard title=" Report Logs " cardClassName="box-3rd card card101">
          <C3Chart
            data={this.state.chartData}
            legend={{ show: true }}
            donut={{ title: "Report Logs" }}
            tooltip={{ contents: tooltipContents }}
            colors={{
              Success: "#ff0000",
              Failure: "#00ff00",
            }}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
